module.exports = __webpack_public_path__ + "static/media/pinterest-social-media-svgrepo-com.aec371b6.svg";